import { NotificationType } from "App/Modules/Models";

export function NotificationFilter() {
    return (type: number) => {
        return NotificationType[type];
    };
}
